/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const faq = () => {
  const faqItems = document.querySelectorAll('.js-faq-item');
  const faqCat = document.querySelectorAll('.js-faq-category');
  const faqCatHolders = document.querySelectorAll('.js-faq-category-holder');

  faqCat.forEach(item => {
    item.addEventListener(
      'click',
      event => {
        faqCat.forEach(elem => {
          if (elem !== item) {
            elem.classList.remove('is-active');
          }
        });
        item.classList.add('is-active');
        faqCatHolders.forEach(elem => {
          if (elem.dataset.cat === item.dataset.cat) {
            elem.classList.add('is-active');
            faqItems.forEach(faqitem => {
              faqitem.classList.remove('is-active');
            });
            elem.querySelectorAll('.js-faq-item')[0].classList.add('is-active');
          } else {
            elem.classList.remove('is-active');
          }
        });
      },
      true,
    );
  });
  faqItems.forEach(item => {
    item.addEventListener(
      'click',
      event => {
        faqItems.forEach(elem => {
          if (elem !== item) {
            elem.classList.remove('is-active');
          }
        });
        item.classList.toggle('is-active');
      },
      true,
    );
  });
};

export default faq;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/faq.js